import React, { useState } from "react";
import { Modal, Title, Text } from "@mantine/core";
import { useProducts } from "../../context/ProductsContext";
import ProductForm from "./ProductForm";

export default function AddProductModal({ opened, onClose, onProductCreated }) {
  const { addProduct } = useProducts();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [modalTitle, setModalTitle] = useState();

  const handleModalTitleChange = (title) => {
    setModalTitle(title);
  };

  const handleSubmit = async (productData) => {
    try {
      setIsSubmitting(true);
      const products = await addProduct(productData);
      if (onProductCreated && products?.length > 0) {
        onProductCreated(products[0].id);
      }
      onClose();
    } catch (error) {
      console.error("Error adding product:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCancel = () => {
    if (!isSubmitting) {
      onClose();
    }
  };

  return (
    <Modal
      opened={opened}
      onClose={handleCancel}
      title={
        <Title size="lg" fw={500}>
          {modalTitle}
        </Title>
      }
      size="xl"
      closeOnClickOutside={!isSubmitting}
      closeOnEscape={!isSubmitting}
      centered
      styles={{
        header: {
          borderBottom: "1px solid var(--border-color)",
        },
      }}
    >
      <ProductForm
        mode="add"
        onSubmit={handleSubmit}
        onCancel={handleCancel}
        isSubmitting={isSubmitting}
        setIsSubmitting={setIsSubmitting}
        onModalTitleChange={handleModalTitleChange}
      />
    </Modal>
  );
}
